import {commonPromise} from '../../http'
import {
    ANSWERLIST,
    SUBMITANSWER,
    BEFORE_RECEIVE_CHECK,
    ORDER_RECIEVE,
    ORDER_RECIEVE_CHECK
} from '../global'

export const getAnswerlists = (data) => commonPromise(data, ANSWERLIST);// 答题列表
export const submitAnswer = (data) => commonPromise(data, SUBMITANSWER);// 答题列表

export const beforeReceiveCheck = (data) => commonPromise(data, BEFORE_RECEIVE_CHECK);// 领取前检查

export const createGiftOrder = (data) => commonPromise(data, ORDER_RECIEVE, 'post');// 创建领取礼物订单

export const orderReceiveCheck = (data) => commonPromise(data, ORDER_RECIEVE_CHECK);// 检查课程领取订单




// WEBPACK FOOTER //
// ./src/api/apiModules/raffleApi.js